import { useTranslation } from "react-i18next";
import React, { useMemo } from "react";
import Select, { components } from "react-select";
import { SelectorIcon } from "@heroicons/react/solid";
import FileCell from "../table/file-cell";
import {ATTACHMENT} from "../../../constants/config";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <div className="field__icon cursor-pointer">
        <SelectorIcon className="h-5 w-5 text-gray-400 " aria-hidden="true" />
      </div>
    </components.DropdownIndicator>
  );
};

const indicatorSeparatorStyle = {
  display: "none",
};

const IndicatorSeparator = ({ innerProps }) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

const FileOption = (props) => {
  return (
      <components.Option  {...props} >
        <FileCell file={props.data.data}/>
      </components.Option>
  );
};

const InputSelect = ({
  label,
  isShowLabel  = true,
  isRequired,
  name,
  options = [],
  defaultValue = "",
  value,
  onChange,
  isLoading,
  isDisabled,
  errors,
  warning,
  warningRegex,
  isMulti,
  isClearable = false,
  customOption = false,
  isInsideTarget = false,
  size = "compact"
}) => {
  const { t } = useTranslation();

  let selectComponents = { IndicatorSeparator, DropdownIndicator };

  if(customOption === ATTACHMENT){
    selectComponents = {...selectComponents, ...{Option: FileOption}};
  }

  const isCompact = size === "compact";

  const selectStyles = useMemo(() => ({
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      minHeight: isCompact ? "1.875rem" : "2.75rem",
      boxShadow: "none",
      paddingTop: isCompact ? "0" : "0.375rem",
      paddingBottom: isCompact ? "0" : "0.375rem",
    }),
    valueContainer: (base) => ({
      ...base,
      paddingTop: isCompact ? "0.125rem" : "0.375rem",
      paddingBottom: isCompact ? "0.125rem" : "0.375rem",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    singleValue: (base) => ({
      ...base,
      margin: 0,
    }),
    placeholder: (base) => ({
      ...base,
      margin: 0,
    }),
  }), [isCompact]);

  return (
    <div>
      {
        isShowLabel && (
              <label
                  htmlFor={name}
                  className="block text-sm font-medium mb-1 text-gray-700"
              >
                {label} {isRequired && <span className="text-red-500">*</span>}
              </label>
          )
      }
      <Select
        classNamePrefix="react-select"
        className={`react-select-container
         ${isCompact ? "react-select-container-compact" : ""}
         ${errors ? "react-select-container-error" : ""}
         ${isInsideTarget ? "react-select-inside-menu" : ""}
         `}
        components={selectComponents}
        isLoading={isLoading}
        isMulti={isMulti}
        isDisabled={isDisabled}
        onChange={(selectedOption) => {
          onChange(selectedOption);
        }}
        isClearable={isClearable}
        menuPortalTarget={isInsideTarget ? false: document.body}
        styles={selectStyles}
        name={name}
        options={options}
        placeholder={t("app.common.placeholder", {
          field: label.toLowerCase(),
        })}
        defaultValue={defaultValue}
        value={value}
      />
      {errors && errors.type === "required" && (
        <p className="mt-2 text-sm text-red-600">
          {warning ? warning : t("app.warning.description", { field: label })}
        </p>
      )}
      {errors && errors.type === "validate" && (
        <p className="mt-2 text-sm text-red-600">
          {warning ? warning : t("app.warning.description", { field: label })}
        </p>
      )}
      {errors && errors.type === "pattern" && (
        <p className="mt-2 text-sm text-red-600">
          {warningRegex
            ? warningRegex
            : t("app.warning.description_regex", { field: label })}
        </p>
      )}
    </div>
  );
};

InputSelect.defaultProps = {
  isMulti: false,
};

export default InputSelect;
